module.exports = __webpack_public_path__ + "_assets/img/info.f0279d79.svg";